import type { ToolbarProps, View } from "react-big-calendar"
import { cn } from "~/ui-rtk/utils/tailwind-utils"

const VIEW_LABELS: Partial<Record<View, string>> = {
  month: "Month",
  week: "Week",
  day: "Day",
  agenda: "Agenda",
}

export default function CalendarToolbar<
  TEvent extends object,
  TResource extends object,
>({ label, view, views, onView, onNavigate }: ToolbarProps<TEvent, TResource>) {
  const viewList = (Array.isArray(views) ? views : Object.keys(views)) as View[]

  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3">
      <div className="flex items-center gap-3">
        <div className="join">
          <button
            type="button"
            className="btn btn-sm join-item"
            onClick={() => onNavigate("PREV")}
            aria-label="Previous"
          >
            ‹
          </button>
          <button
            type="button"
            className="btn btn-sm join-item"
            onClick={() => onNavigate("TODAY")}
          >
            Today
          </button>
          <button
            type="button"
            className="btn btn-sm join-item"
            onClick={() => onNavigate("NEXT")}
            aria-label="Next"
          >
            ›
          </button>
        </div>
        <span className="text-lg font-medium text-white">{label}</span>
      </div>

      <div className="join">
        {viewList.map(v => (
          <button
            key={v}
            type="button"
            className={cn("btn btn-sm join-item", v === view && "btn-primary")}
            onClick={() => onView(v)}
          >
            {VIEW_LABELS[v] ?? v}
          </button>
        ))}
      </div>
    </div>
  )
}
